import { CLAUDE_SETTINGS } from "@/rbac/links.js";

import {
  VIEW_CLAUDE_SETTINGS,
  CREATE_CLAUDE_SETTINGS,
  UPDATE_CLAUDE_SETTINGS,
} from "@/rbac/permissions.js";

function props(route) {
  return {
    page: parseInt(route.query.page) || 1,
    limit: parseInt(route.query.limit) || 10,

    role_id: parseInt(route.query.role_id) || null,
    order_by_role_name: route.query.order_by_role_name || null,

    prompt_id: parseInt(route.query.prompt_id) || null,
    order_by_prompt_name: route.query.order_by_prompt_name || null,

    model_id: parseInt(route.query.model_id) || null,
    order_by_model_name: route.query.order_by_model_name || null,

    max_tokens: parseInt(route.query.max_tokens) || null,
    order_by_max_tokens: route.query.order_by_max_tokens || null,

    rate_limit: parseInt(route.query.rate_limit) || null,
    order_by_rate_limit: route.query.order_by_rate_limit || null,
  };
}

const claudeSettingsRoutes = [
  {
    path: "/nacd-ai-settings",
    component: () =>
      import(
        /* webpackChunkName: "system-layout" */ "@/views/system/Layout.vue"
      ),
    children: [
      {
        path: "",
        name: "ClaudeSettingsIndex",
        meta: {
          title: "NACD AI Settings",
          permission: CLAUDE_SETTINGS,
        },
        props: (route) => props(route),
        component: () =>
          import(
            /* webpackChunkName: "claude-settings-index" */ "@/views/system/claude-settings/Index.vue"
          ),
      },
      {
        path: "create",
        name: "ClaudeSettingsCreate",
        meta: {
          title: "Create NACD AI Settings",
          permission: CREATE_CLAUDE_SETTINGS,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-settings-create" */ "@/views/system/claude-settings/Create.vue"
          ),
      },
      {
        path: ":id/view",
        name: "ClaudeSettingsView",
        meta: {
          title: "View NACD AI Settings",
          permission: VIEW_CLAUDE_SETTINGS,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-settings-view" */ "@/views/system/claude-settings/View.vue"
          ),
      },
      {
        path: ":id/edit",
        name: "ClaudeSettingsEdit",
        meta: {
          title: "Edit NACD AI Settings",
          permission: UPDATE_CLAUDE_SETTINGS,
        },
        props: (route) => ({
          id: parseInt(route.params.id),
        }),
        component: () =>
          import(
            /* webpackChunkName: "claude-settings-edit" */ "@/views/system/claude-settings/Edit.vue"
          ),
      },
    ],
  },
];

export default claudeSettingsRoutes;
